import { MenuActionType, type MenuType } from './type';

export const menus: MenuType[] = [
  {
    key: 'holdstation',
    img: require('@/assets/images/menu/holdstation.png'),
    type: MenuActionType.HYPERLINK,
    to: '/',
    label: 'Holdstation',
  },
  {
    key: 'divider',
    img: '',
    type: MenuActionType.DIVIDER,
    label: 'divider',
    dataAction: '',
  },
  {
    key: 'wallet',
    img: require('@/assets/images/menu/Wallet.png'),
    type: MenuActionType.MODAL,
    label: 'Wallet',
    dataAction: 'download_holdstation_app',
  },
  {
    key: 'berais',
    img: require('@/assets/images/menu/berais.png'),
    type: MenuActionType.HYPERLINK,
    to: 'https://www.berais.land',
    target: '_blank',
    label: 'BerAIs',
    dataAction: 'redirect_berais.land',
  },
  {
    key: 'holdstation-swap',
    img: require('@/assets/images/menu/Game.png'),
    type: MenuActionType.HYPERLINK,
    to: 'https://hold.so/swap',
    target: '_blank',
    label: 'Holdstation Swap',
    dataAction: 'redirect_hold.so',
  },
  {
    key: 'holdstation-defuture',
    img: require('@/assets/images/menu/DeFutures.png'),
    type: MenuActionType.MODAL,
    label: 'DeFutures',
  },
  {
    key: 'zk-starter',
    img: require('@/assets/images/menu/ZKStarter.png'),
    type: MenuActionType.MODAL,
    label: 'zkStarter',
  },
  {
    key: 'divider',
    img: '',
    type: MenuActionType.DIVIDER,
    label: 'divider',
  },
  {
    key: 'folder',
    img: require('@/assets/images/menu/Folder.png'),
    activeImg: require('@/assets/images/menu/Drop.png'),
    type: MenuActionType.VIEWFAN,
    label: 'Folder',
  },
];

export const exandMore: MenuType[] = [
  {
    key: 'whitepaper',
    img: require('@/assets/images/menu/Whitepaper.png'),
    type: MenuActionType.HYPERLINK,
    to: 'https://static.holdstation.com/doc/Holdstation-Whitepaper.pdf',
    target: '_blank',
    label: 'Whitepaper',
    dataAction: 'redirect_whitepaper',
  },
  {
    key: 'holdstation-docs',
    img: require('@/assets/images/menu/Docs.png'),
    type: MenuActionType.HYPERLINK,
    to: 'https://docs.holdstation.com/holdstation-docs-en',
    target: '_blank',
    label: 'Docs',
    dataAction: 'redirect_docs',
  },
  {
    key: 'holdstation-blog',
    img: require('@/assets/images/menu/Blog.png'),
    type: MenuActionType.HYPERLINK,
    to: 'https://blog.holdstation.com/',
    target: '_blank',
    label: 'Blog',
    dataAction: 'redirect_blog',
  },
  {
    key: 'holdstation-campaign',
    img: require('@/assets/images/menu/Campaign.png'),
    type: MenuActionType.HYPERLINK,
    to: '/campaign',
    label: 'Campaign',
    target: '_self',
  },
  {
    key: 'holdstation-community',
    img: require('@/assets/images/menu/Community.png'),
    type: MenuActionType.HYPERLINK,
    to: 'https://link3.to/holdstation',
    target: '_blank',
    label: 'Community',
    dataAction: 'redirect_community_holdstation',
  },
];

export const menus_mobile: MenuType[] = [
  {
    key: 'holdstation',
    img: require('@/assets/images/menu/holdstation.png'),
    type: MenuActionType.HYPERLINK,
    to: '/',
    label: 'Holdstation',
  },
  {
    key: 'berais',
    img: require('@/assets/images/menu/berais.png'),
    type: MenuActionType.HYPERLINK,
    to: 'https://www.berais.land',
    target: '_blank',
    label: 'BerAIs',
    dataAction: 'redirect_berais.land',
  },
  {
    key: 'menu-mobile',
    img: require('@/assets/images/menu/List.png'),
    type: MenuActionType.MODAL,
    label: 'More',
  },
  {
    key: 'folder',
    img: require('@/assets/images/menu/Folder.png'),
    activeImg: require('@/assets/images/menu/Drop.png'),
    type: MenuActionType.VIEWFAN,
    label: 'Folder',
  },
];

export const menus_mobile_more: MenuType[] = [
  {
    key: 'holdstation-swap',
    img: require('@/assets/images/menu/Game.png'),
    type: MenuActionType.HYPERLINK,
    to: 'https://hold.so/swap',
    target: '_blank',
    label: 'Holdstation Swap',
    dataAction: 'redirect_hold.so',
  },
  {
    key: 'holdstation-defuture',
    img: require('@/assets/images/menu/DeFutures.png'),
    type: MenuActionType.MODAL,
    label: 'DeFutures',
  },
  {
    key: 'wallet',
    img: require('@/assets/images/menu/Wallet.png'),
    type: MenuActionType.MODAL,
    label: 'Wallet',
    dataAction: 'download_holdstation_app',
  },
  {
    key: 'zk-starter',
    img: require('@/assets/images/menu/ZKStarter.png'),
    type: MenuActionType.MODAL,
    label: 'zkStarter',
  },
];
